// extracted by mini-css-extract-plugin
module.exports = {"shp2-detail-O":"O_shp2-detail-O__oYPM9"};